import { ArrowRightIcon } from "@cpj-ai/panel-npm-package";
import { Button, Card, CardBody, Divider } from "@heroui/react";
import AiJobPositionCreatorLayout from "./layout";

interface IChooseMethodSelectionProps {
  setSelectedMethod: (method: "voice" | "file" | null) => void;
  handleNextStep: () => void;
}

const ChooseMethodSelection = ({ setSelectedMethod, handleNextStep }: IChooseMethodSelectionProps) => {
  return (
    <AiJobPositionCreatorLayout description="Choose your preferred method to create a job post. You can either record your voice, upload a file, or skip to fill the details manually.">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card
          className="cursor-pointer hover:shadow-lg transition-shadow py-6"
          isPressable
          onPress={() => setSelectedMethod("voice")}
        >
          <CardBody className="flex flex-col items-center gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 24 24"
              className="fill-primary-500"
            >
              <path d="M16 12V6c0-2.217-1.785-4.021-3.979-4.021a1 1 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4m-6 0V6c0-1.103.897-2 2-2a1 1 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2" />
              <path d="M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6" />
            </svg>
            <h3 className="text-lg font-semibold">Voice Recording</h3>
            <p className="text-center text-gray-600">Record your job description by voice</p>
          </CardBody>
        </Card>

        <Card
          className="cursor-pointer hover:shadow-lg transition-shadow py-6"
          isPressable
          onPress={() => setSelectedMethod("file")}
        >
          <CardBody className="flex flex-col items-center gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 24 24"
              fill="none"
              className="stroke-primary-500"
            >
              <g strokeLinecap="round" strokeWidth="2">
                <path
                  strokeLinejoin="round"
                  d="M14.186 2.753v3.596c0 .487.194.955.54 1.3a1.85 1.85 0 0 0 1.306.539h4.125"
                />
                <path
                  strokeLinejoin="round"
                  d="M20.25 8.568v8.568a4.25 4.25 0 0 1-1.362 2.97a4.28 4.28 0 0 1-3.072 1.14h-7.59a4.3 4.3 0 0 1-3.1-1.124a4.26 4.26 0 0 1-1.376-2.986V6.862a4.25 4.25 0 0 1 1.362-2.97a4.28 4.28 0 0 1 3.072-1.14h5.714a3.5 3.5 0 0 1 2.361.905l2.96 2.722a2.97 2.97 0 0 1 1.031 2.189"
                />
                <path strokeMiterlimit="10" d="M12 10.499v6.774" />
                <path strokeLinejoin="round" d="m15.106 13.35l-2.665-2.665a.62.62 0 0 0-.882 0l-2.665 2.666" />
              </g>
            </svg>
            <h3 className="text-lg font-semibold">Upload File</h3>
            <p className="text-center text-gray-600">Upload a file containing your job description</p>
          </CardBody>
        </Card>
      </div>

      <Divider className="my-4" />

      <Button
        variant="light"
        color="primary"
        endContent={<ArrowRightIcon className="w-6 h-6 stroke-primary-500 mt-2" />}
        onPress={handleNextStep}
        fullWidth
        className="mt-2"
      >
        Skip & Fill Manually
      </Button>
    </AiJobPositionCreatorLayout>
  );
};

export default ChooseMethodSelection;
